/**
 * «Скопировать вчера»: что перенести в открытый день.
 *
 * Источник — строго вчера (юзер 10/15: «строго вчера нужно брать») и только
 * внутри этой недели: в понедельник «вчера» — прошлая неделя, с неё не тянем.
 * Только пока на открытый день ещё ничего не введено: тогда переносим весь
 * вчерашний день (мои часы людей и работ из листа). Есть хоть одна запись на
 * сегодня — кнопки нет: «вчера 5, сегодня 6 — что подтянется?» (юзер 10/15).
 * Вчера пусто — тоже нет.
 *
 * @param {object} p
 * @param {string} p.currentDate YYYY-MM-DD открытого дня
 * @param {Array} p.weekRecords записи недели
 * @param {Array<number>} p.selectedEmployeeIds
 * @param {Array<number>} p.selectedJobIds
 * @param {number|null} p.currentUserId
 * @param {Map<string, object>} p.recordByCell записи открытого дня, ключ `${employeeId}|${jobId}`
 * @returns {{ from: string, entries: Array<{employeeId:number, jobId:number, hours:number}> } | null}
 */
export function previousDayPlan({ currentDate, weekRecords, selectedEmployeeIds, selectedJobIds, currentUserId, recordByCell }) {
    const d = new Date(currentDate + 'T00:00:00');
    if (d.getDay() === 1) return null;
    d.setDate(d.getDate() - 1);
    const from = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

    const empSet = new Set(selectedEmployeeIds);
    const jobSet = new Set(selectedJobIds);
    if (recordByCell.size > 0) return null; // на сегодня уже что-то введено
    const entries = weekRecords
        .filter(r => !r.isDeleted && r.hours > 0 && r.workDate === from
            && empSet.has(r.employeeId) && jobSet.has(r.jobId)
            && (currentUserId == null || Number(r.createdByUserId) === Number(currentUserId)))
        .map(r => ({ employeeId: r.employeeId, jobId: r.jobId, hours: r.hours }));

    return entries.length ? { from, entries } : null;
}
